import React from 'react';

import MuiListSubheader, {
  ListSubheaderProps as MuiListSubheaderProps,
} from '@mui/material/ListSubheader';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const ListSubheader = withCoreProps<ListSubheaderProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<ListSubheaderProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiListSubheader {...props} className={clsxClass}>
        {children}
      </MuiListSubheader>
    );
  },
);

export interface ListSubheaderProps extends MuiListSubheaderProps, CoreProps {}
